import {
  BillingMethodList,
  BillingMethodListItem,
} from 'billing/components/BillingMethodList'
import BillingMethod from 'billing/models/BillingMethod'
import PaymentMethodSelectorViewModel from 'billing/payment-methods/PaymentMethodSelectorViewModel'
import ContentLoading from 'components/ContentLoading'
import { useTask } from 'hooks/mobx-hooks'
import { observer } from 'mobx-react'
import { expr } from 'mobx-utils'
import * as React from 'react'

interface PaymentMethodSelectorProps {
  vm: PaymentMethodSelectorViewModel
}

/**
 * The PaymentMethodSelector
 */
export default observer(function PaymentMethodSelector({
  vm,
}: PaymentMethodSelectorProps) {
  return vm.prepare.pending ? (
    <ContentLoading compact />
  ) : (
    <BillingMethodList
      onAddClick={vm.canAddPaymentMethod ? vm.newPaymentMethod : undefined}
      onAddDisabled={vm.disabled}
    >
      {vm.paymentMethods.map((method) => (
        <BillingMethodListItemContainer
          key={method.id}
          vm={vm}
          method={method}
        />
      ))}
    </BillingMethodList>
  )
})

interface BillingMethodListItemContainerProps {
  method: BillingMethod
  vm: PaymentMethodSelectorViewModel
}

/**
 " Billing Method List Item Container
 */
const BillingMethodListItemContainer = observer(
  function BillingMethodListItemContainer({
    method,
    vm,
  }: BillingMethodListItemContainerProps) {
    const select = useTask.resolved(() => vm.selectMethod(method), [vm, method])
    const isSelected = expr(() => vm.selectedPaymentMethod === method)
    return (
      <BillingMethodListItem
        billingMethod={method}
        onClick={isSelected ? undefined : select}
        selected={isSelected}
        disabled={vm.selectMethod.pending}
        busy={select.pending}
      />
    )
  },
)
